export const transformSubmitData = data => {
  const userEmailConfig = {}

  if (data.emailProvider) userEmailConfig.provider = data.emailProvider
  if (data.smtpAddress) userEmailConfig.smtpAddress = data.smtpAddress
  if (data.smtpPort !== '' && data.smtpPort !== null && data.smtpPort !== undefined) {
    userEmailConfig.smtpPort = Number(data.smtpPort)
  }
  if (data.encryptionMethod) userEmailConfig.encryptionMethod = data.encryptionMethod
  if (data.emailConfigUsername) userEmailConfig.username = data.emailConfigUsername
  if (data.emailConfigPassword !== undefined)
    userEmailConfig.password = data.emailConfigPassword || ''

  return {
    ...data,
    cpf: data.cpf.replace(/\D/g, ''),
    sendEmail: !!data.sendEmail,
    userEmailConfig,
  }
}
